import { UNITS_OF_MEASURE_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/units_of_measure_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
